<template>
  <div>
    <Navigation />
    <div class="content mt-4">
      <div class="container content--demo-detail">
        <div class="row">
          <div class="col-12 mt-5">
            <div>
              <div class="page-block--title">Submission by {{ demo.artist_name }} </div>
              <SourceLabel :source="demo.page_name" />
            </div>
            <hr style="border-color: gray;" />

          </div>
          <div class="col-xs-12 col-sm-12 col-lg-6 mt-2">

            <div><strong>Artist</strong> {{ demo.artist_name }}</div>
            <div><strong>Track</strong> {{ demo.track_name }}</div>
            <div class="page--link"><strong>Email</strong> <span class="page--url"><a :href="'mailto:' + demo.artist_email" target="_blank">
                  {{ demo.artist_email
                }}<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" height="11px" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-external-link">
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                    <polyline points="15 3 21 3 21 9"></polyline>
                    <line x1="10" y1="14" x2="21" y2="3"></line>
                  </svg>
                </a></span></div>

            <div><strong>Submitted </strong> <span v-if="getDemoDate(demo.created_at) == 'Today'"><strong>{{ getDemoDate(demo.created_at) }}</strong></span>
              <span v-else>{{ getDemoDate(demo.created_at) }}</span>
            </div>
            <hr />
            <div><strong>Contest</strong> {{ demo.contest_name }}</div>
            <hr />
            <div><strong>Status</strong> {{ demo.status }}</div>
          </div>
          <div class="col-xs-12 col-sm-12 col-lg-6 mt-2">
            <div class="block--content-item player--audio" style="width: 100%">
              <div class="demo--player" style="width: 100%">
                <NativePlayer v-if="demo.demo_url != null" autoplay="false" :file="demo.demo_url"></NativePlayer>

                <a style="text-decoration: none;" :href="demo.soundcloud_url" target="_blank">
                  <div class="demo--soundcloud" v-if="demo.soundcloud_url != null"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" width="20" fill="white" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                      <g>
                        <g>
                          <path d="M432,240c-5.696,0-11.296,0.608-16.672,1.76C408.128,169.024,346.592,112,272,112c-8.832,0-16,7.168-16,16v256
                   c0,8.832,7.168,16,16,16h160c44.128,0,80-35.872,80-80C512,275.904,476.128,240,432,240z" />
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M208,144c-8.832,0-16,7.168-16,16v224c0,8.832,7.168,16,16,16c8.832,0,16-7.168,16-16V160
                   C224,151.168,216.832,144,208,144z" />
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M144,208c-8.832,0-16,7.168-16,16v160c0,8.832,7.168,16,16,16c8.832,0,16-7.168,16-16V224
                   C160,215.168,152.832,208,144,208z" />
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M80,208c-8.832,0-16,7.168-16,16v160c0,8.832,7.168,16,16,16c8.832,0,16-7.168,16-16V224C96,215.168,88.832,208,80,208z" />
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M16,256c-8.832,0-16,7.168-16,16v96c0,8.832,7.168,16,16,16c8.832,0,16-7.168,16-16v-96C32,263.168,24.832,256,16,256z" />
                        </g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                    </svg>
                    Play on Soundcloud</div>
                </a>
                <a style="text-decoration: none;" :href="demo.dropbox_url" target="_blank">
                  <div class="demo--dropbox" v-if="demo.dropbox_url != null"><svg version="1.1" width="20" fill="white" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                      <g>
                        <g>
                          <polygon points="361.376,0 256,88.672 407.872,183.168 512,99.136 		" />
                        </g>
                      </g>
                      <g>
                        <g>
                          <polygon points="150.624,0 0,99.104 104.16,183.168 256,88.672 		" />
                        </g>
                      </g>
                      <g>
                        <g>
                          <g>
                            <polygon points="0,267.232 150.624,366.368 256,277.696 104.128,183.168 			" />
                            <polygon points="407.84,183.168 256,277.696 361.376,366.368 512,267.232 			" />
                          </g>
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M368.992,399.648c-2.656,1.76-5.728,2.624-8.768,2.624c-3.68,0-7.328-1.28-10.304-3.744L256,319.488l-93.92,79.04
                   c-5.408,4.544-13.184,4.992-19.104,1.12L96,368.736V416l160.32,96L416,416v-47.296L368.992,399.648z" />
                        </g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                    </svg>


                    Play on Dropbox</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import axios from "axios";
  import NativePlayer from "../components/NativePlayer";
  import SourceLabel from "../components/SourceLabel";
  export default {
    name: "DemoDetail",
    components: {
      NativePlayer,
      SourceLabel
    },
    methods: {
      getDemoDate(timestamp) {
        return this.timeConverter(timestamp);
      },
      timeConverter(UNIX_timestamp) {
        var a = new Date(UNIX_timestamp * 1000);
        if (!this.isToday(a)) {
          var months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];
          var year = a.getFullYear();
          var month = months[a.getMonth()];
          var date = a.getDate();
          var time = date + " " + month + " " + year + " ";
          return time;
        } else {
          return "Today";
        }
      },
      isToday(someDate) {
        const today = new Date();
        return (
          someDate.getDate() == today.getDate() &&
          someDate.getMonth() == today.getMonth() &&
          someDate.getFullYear() == today.getFullYear()
        );
      },
    },
    mounted() {
      var self = this;
      this.isLoading = true;
      axios({
          method: "GET",
          crossdomain: true,
          headers: {
            "Content-Type": "Content-Type:application/json"
          },
          url: "https://api.contestcrate.com/demo/" + self.demo_id,
        })
        .then(function(response) {
          self.demo = response.data;
          self.editted = self.trueCopy(self.page);
          self.isLoading = false;
        })
        .catch(function(error) {
          self.errors = error.response.data;
          self.isLoading = false;
        });
    },
    data() {
      return {
        isLoading: false,
        fullPage: true,
        demo_id: this.$route.params.id,

        demo: {},
      };
    },
  };
</script>